import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

// Test Modules
import HomeValueBanner from 'org/modules/HomeTest/components/HomeValueBanner/HomeValueBanner';
import EarnStores from 'org/modules/HomeTest/components/EarnStores/EarnStores';
import MarketingTopBanner from 'org/modules/HomeTest/components/MarketingTopBanner/MarketingTopBanner';

import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';

// Modules
import { ShowOnMQ } from 'core/modules/MediaQueries/MediaQueries';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';
import RedirectToTargetLandingPage from 'core/modules/RedirectToTargetLandingPage/RedirectToTargetLandingPage';
import PageErrorBoundary from 'core/modules/ErrorBoundaries/PageErrorBoundary';
import LetterboxTOF from 'core/modules/LetterboxTOF/LetterboxTOF';
import InfoBar from 'core/modules/InfoBar/InfoBar';
import FavoriteStores from 'core/modules/FavoriteStores/FavoriteStores';
import TopStores from 'core/modules/TopStores/TopStores';
import FeaturedDeals from 'core/modules/FeaturedDeals/FeaturedDeals';
import GiftGuide from 'core/modules/GiftGuide/GiftGuide';
import TrendingAndSeasonalOffers from 'core/modules/TrendingAndSeasonalOffers/TrendingAndSeasonalOffers';
import EmailOptIn from 'core/modules/EmailOptIn/EmailOptIn';
import ExploreCategories from 'core/modules/ExploreCategories/ExploreCategories';
import StickyFooter from 'core/modules/StickyFooter/StickyFooter';
import QuickLinksTray from 'core/modules/QuickLinksTray/QuickLinksTray';
import PopularOffers from 'core/modules/PopularOffers/PopularOffers';
import MarketingMerchantsHome from 'core/modules/MarketingMerchantsHome/MarketingMerchantsHome';
import InfoBarMarketing from 'core/modules/InfoBarMarketing/InfoBarMarketing';
import HowItWorks from 'core/modules/HowItWorks/HowItWorks';
import BonusOffers300x250 from 'core/modules/BonusOffers300x250/BonusOffers300x250';
import PersonalizedTopOffers from 'core/modules/PersonalizedTopOffers/PersonalizedTopOffers';
import TrendingStores from 'core/modules/TrendingStores/TrendingStores';
import SeasonalFeatured from 'core/modules/SeasonalFeatured/SeasonalFeatured';
import TopEarn from 'core/modules/TopEarn/TopEarn';
import BuyOnlinePickupInstore from 'core/modules/BuyOnlinePickupInstore/BuyOnlinePickupInstore';
import CreditCardMarketingBanner from 'core/modules/CreditCardMarketingBanner/CreditCardMarketingBanner';
import HomeSignInNag from 'org/modules/HomeSignInNag/HomeSignInNag';
import InstoreCuratedOffers from 'core/modules/Instore/InstoreCuratedOffers/InstoreCuratedOffers';
import ForYouBecauseYouShoppedList from 'core/modules/ForYouBecauseYouShoppedList/ForYouBecauseYouShoppedList';
import EarningsSnapshot from 'core/modules/EarningsSnapshot/EarningsSnapshot';
import PickFavorites from 'core/modules/PickFavorites/PickFavorites';
import RecentMemberOrders from 'core/modules/RecentMemberOrders/RecentMemberOrders';

// Selectors
import { selectUserIsIdentified } from 'core/selectors/user';

// Hooks
import { useShouldShowNewMembersView } from 'core/hooks/useShouldShowNewMembersView';

import ShopWifiHiw from 'org/modules/ShopWifi/components/ShopWifiHiw/ShopWifiHiw';
import FeaturedOffersLogo from 'core/modules/FeaturedOffersLogo/FeaturedOffersLogo';
import HomeButtonBenefits from 'core/modules/HomeButtonBenefits/HomeButtonBenefits';
import Testimonials from 'core/modules/Testimonials/Testimonials';
import StickyCtaBar from 'core/modules/StickyCtaBar/StickyCtaBar';
import MarketingBanner from 'core/modules/MarketingBanner/MarketingBanner';

import './HomeTest.scss';

function MHP() {
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const shouldShowNewMembersView = useShouldShowNewMembersView();

  useEffect(() => { document.documentElement.classList.add('mn_homeTest', 'mn_MHP'); }, []);

  if (shouldShowNewMembersView) {
    return (
      <>
        <HomeValueBanner />
        <MarketingTopBanner />
        <EarnStores />
        <HowItWorks />
        <Testimonials forceUseCarousel={!isMobileMQ} />
        <TrendingStores />
        <FavoriteStores />
        <div className="mn_pageTopWrap">
          <LetterboxTOF />
          <InfoBar />
        </div>
        <MarketingMerchantsHome />
        <TopStores />
        <PersonalizedTopOffers />
        <ExploreCategories />
        <FeaturedDeals />
        <PopularOffers />
        <GiftGuide />
        <StickyFooter />
        <EmailOptIn />
        <InstoreCuratedOffers />
        <TrendingAndSeasonalOffers />
        <CreditCardMarketingBanner />
        <QuickLinksTray />
      </>
    );
  }

  if (isMobileMQ) {
    return (
      <>
        <HomeValueBanner />
        <MarketingTopBanner />
        <EarnStores />
        <HowItWorks />
        <Testimonials forceUseCarousel={!isMobileMQ} />
        <TrendingStores isInverted />
        <FavoriteStores />
        <div className="mn_pageTopWrap">
          <LetterboxTOF />
          <InfoBar />
        </div>
        <TopStores />
        <ExploreCategories />
        <FeaturedDeals />
        <PopularOffers />
        <GiftGuide />
        <MarketingMerchantsHome />
        <RecentMemberOrders />
        <PickFavorites />
        <StickyFooter />
        <EarningsSnapshot />
        <EmailOptIn />
        <ForYouBecauseYouShoppedList />
        <InstoreCuratedOffers />
        <TrendingAndSeasonalOffers />
        <CreditCardMarketingBanner />
        <QuickLinksTray />
      </>
    );
  }

  /* tablet and desktop */
  return (
    <>
      <HomeValueBanner />
      <EarnStores />
      <ShopWifiHiw title="How to earn miles with MileagePlus Shopping" />
      <Testimonials forceUseCarousel={!isMobileMQ} />
      <div className="mn_pageTopWrap">
        <ContentWrap desktop className="mn_carouselAndTileContent">
          <LetterboxTOF />
          <div className="mn_infoBarMarketingTile">
            <ShowOnMQ desktop><InfoBarMarketing className="mn_infoBarMarketingTileLink" /></ShowOnMQ>
          </div>
        </ContentWrap>
        <InfoBar />
        <TopStores label="Extra" isAllStores />
      </div>
      <div className="mn_pageBottomWrap">
        <ContentWrap xxl>
          <div className="mn_dealsAndOffersContent">
            <div className="mn_mainColumn">
              <ShowOnMQ xxl><BonusOffers300x250 /></ShowOnMQ>
              <FeaturedDeals />
              <ShowOnMQ xxl><GiftGuide /></ShowOnMQ>
              <MarketingMerchantsHome />
              <TrendingStores />
              <ShowOnMQ tablet l xl>
                <PopularOffers />
                <GiftGuide />
              </ShowOnMQ>
              <FavoriteStores />
              <InstoreCuratedOffers />
              <TrendingAndSeasonalOffers />
            </div>
            <ShowOnMQ xxl><PopularOffers /></ShowOnMQ>
          </div>
        </ContentWrap>
        <CreditCardMarketingBanner />
      </div>
      <StickyFooter />
    </>
  );
}

function VHP() {
  useEffect(() => { document.documentElement.classList.add('mn_homeTest', 'mn_VHP'); }, []);

  return (
    <>
      <HomeValueBanner />
      <ShowOnMQ mobile>
        <MarketingTopBanner />
        <EarnStores />
        <HowItWorks />
        <Testimonials />
        <ExploreCategories />
      </ShowOnMQ>
      <ShowOnMQ tablet desktop>
        <EarnStores />
        <ShopWifiHiw title="How to earn miles with MileagePlus Shopping" />
        <Testimonials />
        <HomeButtonBenefits />
        <FeaturedOffersLogo />
        <TrendingStores />
        <MarketingBanner />
        <StickyCtaBar />
      </ShowOnMQ>
      <ShowOnMQ mobile>
        <SeasonalFeatured />
        <FeaturedDeals />
        <TopEarn />
        <TopStores />
        <BuyOnlinePickupInstore />
        <TrendingAndSeasonalOffers />
        <HomeSignInNag forceShowSmallSignInOnly />
      </ShowOnMQ>
    </>
  );
}

function Home() {
  const userIsIdentified = useSelector(selectUserIsIdentified);

  return (
    <RedirectToTargetLandingPage>
      <PageErrorBoundary>
        {userIsIdentified ? <MHP /> : <VHP />}
      </PageErrorBoundary>
    </RedirectToTargetLandingPage>
  );
}

export default Home;
